import { DatePipe } from '@angular/common'
import type { PipeTransform } from '@angular/core'
import { Pipe, inject } from '@angular/core'

import { InternationalizationService } from '../../services/internationalization.service'

@Pipe({ name: 'localizedDate' })
export class LocalizedDatePipe implements PipeTransform {
  private readonly datePipe = inject(DatePipe)
  private readonly i18nService = inject(InternationalizationService)

  // Default format if none is provided
  private readonly defaultFormat = 'd MMMM yyyy'
  // Default locale if the active language isn't a real Angular locale (qqx)
  private readonly defaultLocale = 'nl'

  transform(
    value: Date | string | number | null | undefined,
    format?: string
  ): string | null {
    if (value == null) {
      return null // Return null if the value is null or undefined
    }

    // The active translation language, not the account's stored preference,
    // so /en pages format dates in English even for anonymous visitors and
    // even if the signed-in user's own preference is Dutch.
    const activeLocale = this.i18nService.getLanguagePreference()
    const locale = activeLocale === 'qqx' ? this.defaultLocale : activeLocale

    const displayFormat = format ?? this.defaultFormat

    return this.datePipe.transform(value, displayFormat, undefined, locale)
  }
}
